export default __webpack_public_path__ + "static/ogg-book-c998af728ea486a08031f3f44ddf0667.woff";